import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";

const API = `${config.API_BASE_URL}/api/products`;
const CATEGORY_API = `${config.API_BASE_URL}/api/categories`;

const AdminProducts = () => {

  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
  name: "",
  description: "",
  carat: "",
  price: "",
  stock: "",
  categoryid: "",
  isfeatured: false
});

  const [image, setImage] = useState(null);

  const [editingId, setEditingId] = useState(null);

  const token = localStorage.getItem("token");

  // =========================
  // LOAD PRODUCTS
  // =========================
  const loadProducts = async () => {

    try {

      const res = await axios.get(API, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = res.data.data || [];

      setProducts(data);
      setFiltered(data);

    } catch (err) {

      console.error("LOAD PRODUCTS ERROR:", err);
    }
  };

  // =========================
  // LOAD CATEGORIES
  // =========================
  const loadCategories = async () => {

    try {

      const res = await axios.get(CATEGORY_API);

      setCategories(res.data.data || []);

    } catch (err) {

      console.error("LOAD CATEGORY ERROR:", err);
    }
  };

  useEffect(() => {

    loadProducts();
    loadCategories();

  }, []);

  // =========================
  // SEARCH
  // =========================
  useEffect(() => {

    let data = [...products];

    if (search.trim()) {

      data = data.filter((p) =>
        (p.name || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    setFiltered(data);

  }, [search, products]);

  // =========================
  // HANDLE INPUT
  // =========================
  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // =========================
  // RESET
  // =========================
  const resetForm = () => {

    setForm({
      name: "",
      description: "",
      carat: "",
      price: "",
      stock: "",
      categoryid: "",
      isfeatured: false
    });

    setImage(null);
    setEditingId(null);
  };

  // =========================
  // SAVE PRODUCT
  // =========================
  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const fd = new FormData();

      fd.append("name", form.name);
      fd.append("description", form.description);
      fd.append("carat", form.carat || 0);
      fd.append("price", form.price);
      fd.append("stock", form.stock);
      fd.append("categoryid", form.categoryid);
      fd.append("isfeatured", form.isfeatured);

console.log("FORM DATA:", form);

for (let pair of fd.entries()) {
  console.log(pair[0], pair[1]);
}

      if (image) {
        fd.append("image", image);
      }

      // UPDATE
      if (editingId) {

        await axios.put(
          `${API}/${editingId}`,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data"
            }
          }
        );

        alert("✅ Product updated");

      } else {

        // ADD
        await axios.post(
          API,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data"
            }
          }
        );

        alert("✅ Product added");
      }

      resetForm();
      loadProducts();

    } catch (err) {

      console.error("SAVE ERROR:", err);

      alert(
        err.response?.data?.message ||
        "Save failed"
      );
    }
  };

  // =========================
  // DELETE
  // =========================
  const deleteProduct = async (id) => {

    const ok = window.confirm(
      "Delete this product?"
    );

    if (!ok) return;

    try {

      await axios.delete(
        `${API}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadProducts();

      alert("✅ Deleted");

    } catch (err) {

      alert(
        err.response?.data?.message ||
        "Delete failed"
      );
    }
  };

  // =========================
  // EDIT
  // =========================
  const editProduct = (p) => {

    setEditingId(p.id);

    setForm({
    name: p.name || "",
    description: p.description || "",
    carat: p.carat || "",
    price: p.price || "",
    stock: p.stock || "",
    categoryid: p.categoryid || "",
    isfeatured: p.isfeatured || false
  });

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (

    <div style={styles.page}>

      <h2 style={styles.title}>
        📦 Product Management
      </h2>

      {/* FORM */}

      <div style={styles.card}>

        <h3>
          {editingId
            ? "✏ Edit Product"
            : "➕ Add Product"}
        </h3>

        <form onSubmit={handleSubmit}>

          <div style={styles.grid}>

            {/* NAME */}
            <div>
              <label style={styles.label}>
                Product Name
              </label>

              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter product name"
                style={styles.input}
                required
              />
            </div>
            <div>
              <label style={styles.label}>
                Description
              </label>

              <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                rows="4"
                style={styles.input}
                placeholder="Product description"
              />
            </div>

            <div>
              <label style={styles.label}>
                Carat
              </label>

              <input
                type="number"
                name="carat"
                value={form.carat}
                onChange={handleChange}
                placeholder="Carat"
                style={styles.input}
              />
            </div>

            {/* PRICE */}
            <div>
              <label style={styles.label}>
                Price
              </label>

              <input
                type="number"
                name="price"
                value={form.price}
                onChange={handleChange}
                placeholder="Enter price"
                style={styles.input}
                required
              />
            </div>

            {/* STOCK */}
            <div>
              <label style={styles.label}>
                Stock
              </label>

              <input
                type="number"
                name="stock"
                value={form.stock}
                onChange={handleChange}
                placeholder="Enter stock"
                style={styles.input}
                required
              />
            </div>

            {/* CATEGORY */}
            <div>
              <label style={styles.label}>
                Category
              </label>

              <select
                name="categoryid"
                value={form.categoryid}
                onChange={handleChange}
                style={styles.input}
                required
              >
                <option value="">
                  Select Category
                </option>

                {categories.map((cat) => (

                  <option
                    key={cat.id}
                    value={cat.id}
                  >
                    {cat.name}
                  </option>

                ))}
              </select>
            </div>
            <div>
              <label style={styles.label}>
                Featured Product
              </label>

              <input
                type="checkbox"
                checked={form.isfeatured}
                onChange={(e) =>
                  setForm({
                    ...form,
                    isfeatured: e.target.checked
                  })
                }
              />

              <span style={{ marginLeft: 10 }}>
                ⭐ Show on Home Page
              </span>
            </div>
            {/* IMAGE */}
            <div>
              <label style={styles.label}>
                Image
              </label>

              <input
                type="file"
                onChange={(e) =>
                  setImage(e.target.files[0])
                }
                style={styles.input}
              />
            </div>

          </div>

          <div style={styles.btnRow}>

            <button
              type="submit"
              style={styles.saveBtn}
            >
              {editingId
                ? "Update Product"
                : "Add Product"}
            </button>

            {editingId && (

              <button
                type="button"
                style={styles.cancelBtn}
                onClick={resetForm}
              >
                Cancel
              </button>

            )}

          </div>

        </form>

      </div>

      {/* SEARCH */}

      <input
        type="text"
        placeholder="Search products..."
        value={search}
        onChange={(e) =>
          setSearch(e.target.value)
        }
        style={styles.search}
      />

      {/* TABLE */}

      <div style={styles.tableWrap}>

        <table style={styles.table}>

          <thead>

            <tr>
              <th>ID</th>
              <th>Image</th>
              <th>Name</th>
              <th>Description</th>
              <th>Carat</th>
              
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Featured</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {filtered.length === 0 ? (

              <tr>
                <td colSpan="7" style={styles.empty}>
                  No products found
                </td>
              </tr>

            ) : (

              filtered.map((p) => (

                <tr key={p.id}>

                  <td>{p.id}</td>

                  <td>

                    {p.image ? (

                      <img
                        src={`${config.IMAGE_BASE_URL}/${p.image}`}
                        alt={p.name}
                        style={styles.image}
                      />

                    ) : (
                      "No Image"
                    )}

                  </td>

                  <td>{p.name}</td>                  
                  <td>{p.description}</td>
                  <td>{p.carat || "-"}</td>
                  <td>
                    {p.categoryname || "-"}
                  </td>

                  <td>
                    ₹{Number(p.price).toFixed(2)}
                  </td>

                  <td>{p.stock}</td>
                                  <td>
                  {p.isfeatured ? "⭐ Yes" : "-"}
                </td>
                  <td>

                    <div style={styles.actionWrap}>

                      <button
                        style={styles.editBtn}
                        onClick={() =>
                          editProduct(p)
                        }
                      >
                        Edit
                      </button>

                      <button
                        style={styles.deleteBtn}
                        onClick={() =>
                          deleteProduct(p.id)
                        }
                      >
                        Delete
                      </button>

                    </div>

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AdminProducts;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    padding: 20,
    background: "#f4f6f9",
    minHeight: "100vh"
  },

  title: {
    marginBottom: 20
  },

  card: {
    background: "#fff",
    padding: 20,
    borderRadius: 10,
    marginBottom: 20
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(220px,1fr))",
    gap: 15
  },

  label: {
    display: "block",
    marginBottom: 8,
    fontWeight: 600
  },

  input: {
    width: "100%",
    padding: 10,
    border: "1px solid #ccc",
    borderRadius: 6,
    boxSizing: "border-box"
  },

  btnRow: {
    marginTop: 20,
    display: "flex",
    gap: 10
  },

  saveBtn: {
    background: "#007bff",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: 6,
    cursor: "pointer"
  },

  cancelBtn: {
    background: "#6c757d",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: 6,
    cursor: "pointer"
  },

  search: {
    width: "100%",
    padding: 12,
    marginBottom: 20,
    borderRadius: 6,
    border: "1px solid #ccc"
  },

  tableWrap: {
    background: "#fff",
    borderRadius: 10,
    overflowX: "auto"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  image: {
    width: 70,
    height: 70,
    objectFit: "cover",
    borderRadius: 6
  },

  actionWrap: {
    display: "flex",
    gap: 10
  },

  editBtn: {
    background: "#ffc107",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer"
  },

  deleteBtn: {
    background: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer"
  },

  empty: {
    textAlign: "center",
    padding: 30
  }
};